var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamtionMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "34px",
    viewBox: "0 0 38 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "7.8613676e-05 0.111 38 0.111 38 33.9999 7.8613676e-05 33.9999"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CONCEPT_extra_info",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tegel_extra_info",
    transform: "translate(-983.000000, -494.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "storingen",
    transform: "translate(959.000000, 484.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.889000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9079,30.9999 L18.9999,4.4059 L34.0919,30.9999 L3.9079,30.9999 Z M37.7709,31.4039 L20.5119,0.9909 C20.1789,0.4039 19.5889,0.1109 18.9999,0.1109 C18.4109,0.1109 17.8219,0.4039 17.4889,0.9909 L0.2289,31.4039 C-0.4281,32.5629 0.4079,33.9999 1.7409,33.9999 L36.2599,33.9999 C37.5919,33.9999 38.4289,32.5629 37.7709,31.4039 L37.7709,31.4039 Z",
    id: "Fill-1",
    fill: "#979797",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001,12.4665 L17.5001,23.9995 L20.5001,23.9995 L20.5001,12.4665 C20.5001,12.2085 20.2911,11.9995 20.0331,11.9995 L17.9671,11.9995 C17.7091,11.9995 17.5001,12.2085 17.5001,12.4665",
    id: "Fill-4",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0001,25.6418 C18.0721,25.6418 17.3211,26.3928 17.3211,27.3208 C17.3211,28.2478 18.0721,28.9998 19.0001,28.9998 C19.9271,28.9998 20.6791,28.2478 20.6791,27.3208 C20.6791,26.3928 19.9271,25.6418 19.0001,25.6418",
    id: "Fill-6",
    fill: "#979797"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamtionMark);
export default __webpack_public_path__ + "static/media/exclamtion-mark.a6d3468e08f88f7c1ee02a9812d90f60.svg";
export { ForwardRef as ReactComponent };